module.exports = "/_next/static/images/43ca1217d44bdabfa1a3d91bd37e6b64-limit-xs.png.webp";